const KNOWN_NAMES = {
  'Мониторинг': 'items.monitoring',
  'Подписка на мониторинг': 'items.subscription',
  'Подписка платформы': 'items.hoster_subscription',
  'Оборудование': 'items.equipment'
};

export const localizeItemName = (name, t) => {
  if (!name) return '';
  const trimmed = String(name).trim();
  const key = KNOWN_NAMES[trimmed];
  if (!key || typeof t !== 'function') return trimmed;
  return t(key, { defaultValue: trimmed });
};
